// project import
import dashboard from './dashboard';
import clientes from './clientes';
import proyectos from './proyectos';
import catalogos from './catalogos';
import sandbox from './sandbox';
import tasksBoard from './tasks-board';



// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    dashboard,
    clientes,
    proyectos,
    catalogos,
    sandbox,
    tasksBoard,
  ]
};

export default menuItems;

